const de = {
    // Common
    'Close': 'Schließen',
    'From': 'Von',
    'To': 'Nach',
    'Distance': 'Distanz',
    'Estimated time': 'Geschätzte Zeit',
    'Level': 'Etage',
    'Search by name, category, building...': 'Nach Name, Kategorie, Gebäude suchen...',
    'Show legend': 'Legende anzeigen',
    'Ask with AI': 'Mit KI fragen',
    'Nothing was found': 'Keine Suchtreffer',
    'd': 'd',
    'h': 'h',
    'min': 'min',
    'Walk': 'Zu Fuß',
    'Bike': 'Fahrrad',
    'Transit': 'Öffentliche Verkehrsmittel',
    'Drive': 'Auto',
    'Start wayfinding': 'Starte Navigation',
    // Location Details
    'Read full description': 'Beschreibung öffnen',
    // Locations list
    'Locations': 'Locations',
    'Directions not available': 'Wegbeschreibung nicht verfügbar',
    'Start directions': 'Starte Wegbeschreibung',
    // Route instructions
    'Previous': 'Zurück',
    'Next': 'Weiter',
    'StepYofX': 'Schritt {{activeStep}} von {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Sie haben Ihr Ziel erreicht',
    'Leave': 'Verlassen',
    'Park': 'Parken',
    'at': 'bei',
    'Building': 'Gebäude',
    'Venue': 'Standort',
    'Take staircase to level': 'Nutzen Sie die Treppe zur Etage',
    'Take the ladder to level': 'Nutzen Sie die Leiter zur Etage',
    'Take elevator to level': 'Nutzen Sie den Aufzug zur Etage',
    'Take escalator to level': 'Nutzen Sie die Rolltreppe zur Etage',
    'Take wheelchair lift to level': 'Nutzen Sie den Rollstuhllift zur Etage',
    'Take wheelchair ramp to level': 'Nutzen Sie die Rollstuhlrampe zur Etage',
    'Exit': 'Verlassen Sie das',
    'Enter': 'Gehe Sie in das',
    'stops': 'Zwischenstopps',
    'and continue': 'und Weg fortsetzen',
    'Continue straight ahead': 'Weiter geradeaus',
    'Go left': 'Links abbiegen',
    'Go sharp left': 'Scharf links abbiegen',
    'Go slight left': 'Leicht links abbiegen',
    'Go right': 'Rechts abbiegen',
    'Go sharp right': 'Scharf rechts abbiegen',
    'Go slight right': 'Leicht rechts abbiegen',
    'Turn around': 'Umdrehen',
    // Wayfinding component
    'Switch': 'Umkehren',
    'Avoid stairs and escalators': 'Treppen und Rolltreppen vermeiden',
    'Include bus transportation': 'Busverkehr einbeziehen',
    'No route found': 'Keine Route gefunden',
    'My position': 'Meine Position',
    'Go!': 'Los!',
    'Directions': 'Wegbeschreibung',
    'Choose departure': 'Startpunkt wählen',
    'Choose destination': 'Ziel wählen',
    // Venue selector
    'Venues': 'Standorte',
    'Select venue': 'Standort wählen',
    'Current': 'Aktuell',
    // QR code dialog
    'Scan QR code': 'QR-Code scannen',
    'Scan the QR code to see the route on your phone': 'Scannen Sie den QR-Code, um die Route auf Ihrem Smartphone anzuzeigen',
    'Done': 'Schließen',
    // Directions
    'Cancel route': 'Route abbrechen',
    'Finish route': 'Route beenden',
    // Share location link
    'Share': 'Teilen',
    'Copy link': 'Link kopieren',
    'QR Code': 'QR code',
    // Opening Hours
    'Open': 'Geöffnet',
    'Closed': 'Geschlossen',
    'Expand opening hours': 'Öffnungszeiten erweitern',
    'Collapse opening hours': 'Öffnungszeiten reduzieren',
    // View Selector
    'Go to view': 'Ansicht wechseln',
    'Close view selector': 'Ansichtsauswahl schließen',
    // Language Selector
    'Select language': 'Sprache auswählen',
    // Accessibility
    'Increase text size to 200%': 'Textgröße auf 200% erhöhen',
    'Decrease text size to 100%': 'Textgröße auf 100% verringern',
    // Map Controls
    'Zoom in': 'Vergrößern',
    'Zoom out': 'Verkleinern',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Nutzungszustimmung',
    'Usage consent message': 'Ask with AI hilft Ihnen, Orte zu finden und sich in diesem Gebäude mithilfe von Künstlicher Intelligenz (KI) zurechtzufinden. Obwohl wir nach Genauigkeit streben, kann die KI manchmal Fehler machen. Bitte überprüfen Sie wichtige Details, bevor Sie losgehen.',
    'Usage consent accept': 'Ich verstehe',
    'Usage consent decline': 'Ablehnen',
    'AI disclaimer': 'Ask with AI kann Fehler machen. Überprüfen Sie wichtige Details, bevor Sie losgehen.',
    // Location Consent
    'Location consent message': 'Um personalisierte Wegbeschreibungen bereitzustellen und Ihnen zu helfen, Orte in der Nähe zu entdecken, möchte Ask with AI auf Ihren Standort zugreifen. Der Chat funktioniert auch ohne Ihren Standort, aber Sie müssen dann einen Startpunkt angeben.',
    'Location consent accept': 'Erlauben',
    'Location consent decline': 'Ablehnen',
};

export default de;
